import { LottieAnimation } from 'components/LottieAnimation/LottieAnimation';
import { useTooltipContext } from 'components/Tooltip/TooltipContext';
import { CmsApiReactionType } from 'modules/cms/api/types/CmsApiReactionType';
import { REACTIONS } from 'modules/cms/constants/reactions';

import {
  CmsReactionTooltipContainer,
  CmsReactionTooltipIcon,
} from './CmsReactionButton.styled';

type Props = {
  onClickReactionButton: (reactionType: CmsApiReactionType) => void;
};

export function CmsReactionButtonTooltip({ onClickReactionButton }: Props) {
  const { closeTooltip } = useTooltipContext();

  return (
    <CmsReactionTooltipContainer data-qa-id="cms-reactions-tooltip">
      {Object.entries(REACTIONS).map(([key, { animation, qaId }]) => (
        <CmsReactionTooltipIcon key={key} data-qa-id={qaId}>
          <LottieAnimation
            data={animation}
            onClick={() => {
              onClickReactionButton(key as CmsApiReactionType);
              closeTooltip();
            }}
            size={{ width: 24, height: 24 }}
          />
        </CmsReactionTooltipIcon>
      ))}
    </CmsReactionTooltipContainer>
  );
}
